import { Box, Grid, Stack, Typography, CircularProgress } from '@mui/material';
import { useLeaderboard } from '@app/hooks/useLeaderboard';
import { RouterLink } from '../RouterLink';
import { TopRankCard } from './TopRankCard';

interface Props {
  showMoreLink?: boolean;
}
export function TopRankers({ showMoreLink }: Props) {
  const { data } = useLeaderboard();

  return (
    <Box sx={{ mb: 4 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" fontWeight="bold" mb={1}>
          Top Rankers
        </Typography>
        {showMoreLink && <RouterLink to="/leaderboard">View All</RouterLink>}
      </Stack>
      <Grid container spacing={{ xs: 0, sm: 4 }}>
        {data ? (
          data.items.slice(0, 3).map(entry => (
            <Grid item xs={4} key={entry.id}>
              <TopRankCard
                rank={entry.semesterRank}
                name={entry.user.displayName}
                avatar={entry.user.profilePicture}
                points={entry.score}
              />
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Stack alignItems="center" justifyContent="center" py={4}>
              <CircularProgress />
            </Stack>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
